<template>
  <div v-if="width > 768">
    <DropdownMenu v-model="isOpen">
      <DropdownMenuTrigger>
        <div class="flex gap-3">
          <figure
            class="md:h-12 md:w-12 h-10 flex items-center justify-center w-10 border-2 border-[#E5E8EE] rounded-full"
          >
            <img
              v-if="avatar"
              :src="avatar"
              alt="alt"
              class="w-full h-full rounded-full object-cover"
            />
            <i v-else class="icon-user text-2xl text-gray-500"></i>
          </figure>
          <div class="flex flex-col gap-1">
            <p class="text-base font-[600]">{{ name }}</p>
            <div
              class="bg-[#21466D] w-max text-[13px] rounded-[5px] px-1.5 py-px text-white"
            >
              {{ role }}
            </div>
          </div>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent class="translate-x-[-10px] min-w-[10px]">
        <DropdownMenuItem class="!px-0 !py-0">
          <div
            class="text-sm flex items-center w-full transition-300 px-2 py-1.5 rounded cursor-pointer text-red hover:bg-red/10"
            @click="$emit('logout')"
          >
            <i class="icon-logout text-2xl/6" />
            <span class="mx-4">{{ $t("logout") }}</span>
          </div>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </div>
  <div v-else>
    <DropdownMenu v-model="isOpen">
      <DropdownMenuTrigger>
        <figure
          class="md:h-12 md:w-12 h-10 flex items-center justify-center w-10 border-2 border-[#E5E8EE] rounded-full"
        >
          <img
            v-if="avatar"
            :src="avatar"
            alt="alt"
            class="w-full h-full rounded-full object-cover"
          />
          <i v-else class="icon-user text-2xl text-gray-500" />
        </figure>
      </DropdownMenuTrigger>
      <DropdownMenuContent class="translate-x-[-10px] min-w-[10px]">
        <DropdownMenuItem>
          <div class="flex w-full">
            <p class="text-base font-[600]">{{ name }}</p>
          </div>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <div class="flex w-full">
            <div
              class="bg-[#21466D] w-max text-[13px] rounded-[5px] px-1.5 py-px text-white"
            >
              {{ role }}
            </div>
          </div>
        </DropdownMenuItem>
        <DropdownMenuItem class="!px-0 !py-0">
          <div
            class="text-sm flex items-center w-full transition-300 px-2 py-1.5 rounded cursor-pointer text-red hover:bg-red/10"
            @click="$emit('logout')"
          >
            <i class="icon-logout text-2xl/6" />
            <span class="mx-4">{{ $t("logout") }}</span>
          </div>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </div>
</template>
<script setup lang="ts">
import { useWindowSize } from "@vueuse/core";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ref } from "vue";

interface Props {
  avatar?: string;
  name?: string;
  role?: string;
}

const isOpen = ref(true);

const { width } = useWindowSize();

defineProps<Props>();

defineEmits(["logout"]);
</script>
